<template>
  <ReviewsAssetsEdit
    :back-to="{ name: ReviewsRouteName.ReviewsProductViewAssets }"
    :documents="product.documents"
    :entity-id="product.id"
    :global-id="product.globalId"
    :screenshots="product.screenshots"
    :documents-fenced="!product.configFlags.documentsEditable"
    :has-screenshots-limited-by-plan="!product.hasPaidPlan"
    subject="product"
    @update="onUpdate"
  >
    <template #tabs>
      <ReviewsProductTabs />
    </template>
  </ReviewsAssetsEdit>
</template>

<script setup lang="ts">
import { inject } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

import ReviewsAssetsEdit from '@/components/ReviewsCommon/ReviewsAssetsEdit/ReviewsAssetsEdit.vue'
import ReviewsProductTabs from '@/components/ReviewsManagement/ReviewsProductTabs.vue'
import type { ProductData } from '@/gql/reviews'
import { showNotification } from '@/helpers/notificationHelper'
import { ReviewsRouteName } from '@/router/types'
import { reloadReviewsProductKey } from '@/symbols/reviewsReloadKeys'

const props = defineProps<{
  product: ProductData
}>()

const { t } = useI18n()
const router = useRouter()
const reloadReviewsProduct = inject(reloadReviewsProductKey) as () => void

async function onUpdate() {
  reloadReviewsProduct()
  showNotification(t('Reviews.product.notifications.savedSuccessfully', { name: props.product.title }), 'success')
  await router.push({ name: ReviewsRouteName.ReviewsProductViewAssets, params: { productId: props.product.id } })
}
</script>
